export default __webpack_public_path__ + "static/conversation-a3d9a673d488ec5ef84871df86b7c73f.png";